
import Vue from 'vue';
import EuCard from '../Card/Card.vue';
import EuExpanderText from '../Elements/ExpanderText.vue';
import AddIcon from '../../../Icons/ArrowDownCircular.vue';
import CloseIcon from '../../../Icons/CloseIcon.vue';
/**
- Pass props <b>elevation</b> to set card's shadow
- Set <b>firstEmpty</b> or <b>secondEmpty</b> on <b>true</b> in the list prop to set unavailable view
- You can modify the expand feature with <b>@click="handleClick"</b>
**/
export default Vue.extend<any, any, any, any>({
  name: 'GeneralMoreItems',
  components: {
    EuCard,
    AddIcon,
    CloseIcon,
    EuExpanderText
  },
  data() {
    return {
      list: [],
      expand: false
    };
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set Card elevation type
     */
    elevation: {
      type: String,
      default: 'flat'
    },
    /**
     * Set title
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Set subtext
     */
    subtext: {
      type: String,
      default: ''
    },
    /**
     * Set list of item
     */
    listContent: {
      type: Array,
      default: () => [
        {
          category: 'Category',
          firstLabel: 'Name',
          firstValue: 'Input Name',
          secondLabel: 'Price (Rp)',
          secondValue: 'Input Price'
        }
      ]
    },
    /**
     * Set label for see more button
     */
    seeMoreLabel: {
      type: String,
      default: 'See more'
    },
    /**
     * Set label for see less button
     */
    seeLessLabel: {
      type: String,
      default: 'View less'
    }
  },
  created() {
    this.list = this.listContent;
  },
  computed: {
    containerHeight() {
      return {
        expand: this.expand,
        first: !this.expand
      };
    },
    computedList() {
      if (this.expand) {
        return this.listContent.length;
      }
      return 1;
    },
    computedArrow() {
      if (this.expand) {
        return `transform: rotate(180deg)`;
      }
      return ``;
    },
    computedButtonLabel() {
      if (this.expand) {
        return this.seeLessLabel;
      }
      return this.seeMoreLabel;
    }
  },
  methods: {
    handleClick(e: any) {
      this.expand = !this.expand;
      /**
       * Method to click expand section
       * @event click
       * @type {function}
       */
      this.$emit('click', e);
    }
  }
});
